import{ ReactNode } from 'react';
import { Alert } from 'antd';

import { useFelaEnhanced } from 'hooks';

import { Icon, IconType } from 'modules/ui';

import * as felaRules from './IotInfo.rules';

export interface IotInfoProps {
    children: ReactNode;
}

export const IotInfo = ({ children }: IotInfoProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <Alert
            className={styles.alert}
            icon={<Icon type={IconType.INFO} className={styles.icon} />}
            showIcon
            message={children}
            type="info"
        />
    );
};
